<template>
    <div class="com-partm5">
    	<dv-scroll-board :config="config" style="width: 100%; height: 100%;" />
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
export default {
    components: {
        MyTitle,
        myEchart
    },
    data() {
        return {
			config: {
				header: ['列1', '列2', '列3'],
				data: []
			}
        }
    },
	mounted() {
        // 获取数据
        this.getData()
    },
	methods: {
        // 获取数据
        getData() {
			let params = { 
				enCode: 'computingpower-left-gaojingliebiao',
			}
			dataInterface.dataFaceApi(params).then(res => {

				let data = res || []
				this.config = {
					header: ['告警时间', '告警内容', '告警等级', '告警服务器'],
					rowNum: 6,
					columnWidth: [80, 250, 350, 120],
					oddRowBGC: 'none',
					index: true,
					evenRowBGC: 'rgba(136, 136, 136, .2)',
					data: data.map(item => {
						
						return [ item.alarm_time, item.alarm_content, `<span style="color: ${item.alarm_level == '严重' ? '#D11818' : (item.alarm_level == '重要' ? '#E5750D' : '#FFC700')};">${item.alarm_level}</span>`, item.alarm_server ]
						// return [ item.alarm_time, item.alarm_content, item.alarm_level, item.alarm_server ]
					})
				}
			})
        }
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm5 {
    width: 100%;
    height: 440px;
}
</style>

<style lang="scss">
@import './comm.scss';
.com-partm5 {
	.dv-scroll-board {
		.header {
			background-color: rgba(8, 109, 106, 0.5) !important;
			.header-item {
				height: 60px !important;
				line-height: 60px !important;
				font-size: $FontSize24;
			}
		}
		.rows {
			.index {
				background: none !important;
			}
			.row-item {
				font-size: $FontSize24;
			}
		}
		// .rows {
		// 	.row-item:nth-child(odd) {
		// 		background: none !important;
		// 	}
		// }
	}
}
</style>